import React from "react";
import { Checkbox, FormControlLabel, InputLabel, Stack, Divider } from "@mui/material";
import { Spinner as ModalSpinner } from "./Spinner";

export const ProviderSelector = ({
  providers,
  handleChangeProvider,
  isLoading,
  noHeader = false,
}) => {
  const isProviderNotEmpty = Object.keys(providers).length;
  const sortedProviders = Object.keys(providers).sort((a, b) => {
    return providers[a].label.localeCompare(providers[b].label);
  });

  if (isLoading)
    return (
      <>
        <Divider />
        <div>Loading...</div>
        <Divider />
        <ModalSpinner open />
      </>
    );

  if (!isProviderNotEmpty)
    return (
      <>
        <Divider />
        <div>No providers in this practice</div>
        <Divider />
      </>
    );

  return (
    <Stack>
      {!noHeader && (
        <>
          <InputLabel sx={{ textAlign: "left" }}>Providers</InputLabel>
          <Divider />
        </>
      )}
      {sortedProviders.map((id) => {
        const { selected, label } = providers[id];
        return (
          <FormControlLabel
            key={id}
            control={
              <Checkbox
                checked={selected}
                onChange={(e) => handleChangeProvider(e, id, label)}
                name={id}
              />
            }
            label={label}
            sx={{
              userSelect: "none",
              textAlign: "left",
              "& .MuiFormControlLabel-label": {
                fontSize: "0.75rem",
                color: "#000000",
              },
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
              padding: "0",
            }}
          />
        );
      })}
    </Stack>
  );
};
